








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PolicyStatusDto, SortOrder } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxPolicyStatus extends Vue {
  private types: PolicyStatusDto[] | null = [];
  public selectedType = new PolicyStatusDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: PolicyStatusDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: PolicyStatusDto) {
    this.$emit("policyStatusSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .policyStatus_IndexAll2(SortOrder.Natural)
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
